import React from 'react';
import isEmpty from 'lodash/isEmpty';
import {
    SiteStructure,
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eventbrite/site-structure';

import { PATHS_WITH_HEADER } from '../common/constants';

import './Page.scss';

export default class Page extends React.PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
    };

    render() {
        const {
            env,
            request,
            user,
            footerLinks,
            children,
            featureFlags,
            location,
        } = this.props;
        let optionalParams = {};

        const shouldHideHeader =
            !isEmpty(featureFlags) &&
            !PATHS_WITH_HEADER.includes(location.pathname);

        if (shouldHideHeader) {
            optionalParams = {
                globalHeader: null,
            };
        }

        const updatedFeatureFlags = {
            ...featureFlags,
            showDoNotSellOrShareDataLinkInFooter: true,
        };

        return (
            <SiteStructure
                env={env}
                request={request}
                user={user}
                featureFlags={updatedFeatureFlags}
                fullScreenMain={true}
                focusDrawerOptions={{ content: '', alwaysInclude: false }}
                footerLinks={footerLinks}
                showMarketingLinks={true}
                {...optionalParams}
            >
                {
                    // Allows us to know if there is a header to substract it's height form the splitContainer
                }
                {!shouldHideHeader && <div />}
                {children}
            </SiteStructure>
        );
    }
}
